import { Controller } from "@hotwired/stimulus";

export default class JumpController extends Controller {
  connect() {
    setTimeout(() => {
      this.jumpToMessage();
    }, 100);
  }

  jumpToMessage() {
    const targetId = this.element.dataset.jumpTo;

    if (!targetId) return;

    const el = document.getElementById(`room_${Current?.room?.id}_message_${targetId}`);

    if (!el) return;

    el.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    this.highlight(el);
  }


  highlight(el) {
    el.classList.remove("highlight");

    requestAnimationFrame(() => {
      el.classList.add("highlight");
    });
  }
}
